module.exports = __webpack_public_path__ + "static/media/gys.9c4d7bf8.png";